"use client";

import { createContext, ReactNode, useState, useEffect } from "react";

export type DialogName = "marcus-challenge"; // Позже можно добавить другие

interface DialogsContextType {
  openDialog: (name: DialogName) => void;
  closeDialog: (name: DialogName) => void;
  isOpen: (name: DialogName) => boolean;
}

export const DialogsContext = createContext<DialogsContextType | undefined>(
  undefined,
);

export function DialogsProvider({ children }: { children: ReactNode }) {
  const [openDialogs, setOpenDialogs] = useState<Set<DialogName>>(new Set());

  // Слушаем изменения hash роута
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1); // Убираем #

      if (hash === "challenge") {
        setOpenDialogs((prev) => new Set(prev).add("marcus-challenge"));
      } else {
        setOpenDialogs((prev) => {
          const next = new Set(prev);
          next.delete("marcus-challenge");
          return next;
        });
      }
    };

    // Проверяем при первой загрузке
    handleHashChange();

    // Слушаем hashchange событие
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const openDialog = (name: DialogName) => {
    setOpenDialogs((prev) => {
      const next = new Set(prev);
      next.add(name);

      // Обновляем hash при открытии
      if (name === "marcus-challenge") {
        window.history.pushState(null, "", "#challenge");
        window.dispatchEvent(new HashChangeEvent("hashchange"));
      }

      return next;
    });
  };

  const closeDialog = (name: DialogName) => {
    setOpenDialogs((prev) => {
      const next = new Set(prev);
      next.delete(name);

      // Удаляем hash при закрытии
      if (name === "marcus-challenge") {
        window.history.pushState(null, "", window.location.pathname);
        window.dispatchEvent(new HashChangeEvent("hashchange"));
      }

      return next;
    });
  };

  const isOpen = (name: DialogName) => openDialogs.has(name);

  return (
    <DialogsContext.Provider value={{ openDialog, closeDialog, isOpen }}>
      {children}
    </DialogsContext.Provider>
  );
}
